<template>
  <MainContainer>
    <div>
      <a-form-model :model="currentForm" :rules="rules" ref="form">
        <div style="position: relative">
          <a-form-model-item :colon="false" label="Show filter" class="switch">
            <a-switch v-model="currentForm.showFilter" />
          </a-form-model-item>
          <LanguageSelect
            v-model="selectedLanguage"
            :langs="langs"
            style="top: 0"
            hide-button
          />
        </div>
        <a-form-model-item
          v-if="currentForm.showFilter"
          :colon="false"
          label="Filter type"
          prop="filterTypes"
          style="max-width: 700px"
          class="filter-types"
        >
          <a-select
            v-model="currentForm.filterTypes"
            mode="multiple"
            size="large"
            placeholder="Choose filter"
            @change="validateFilterTypes"
            @blur="validateFilterTypes"
            @select="handleFilterTypesSelect"
            @deselect="handleFilterTypesDeselect"
          >
            <a-select-option
              v-for="item in currentFilterOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
            <div slot="dropdownRender" slot-scope="menu">
              <v-nodes :vnodes="menu" />
              <a-button
                v-if="currentSelectedMatches?.length"
                type="link"
                @click="SET_FILTER_MODAL_OPENED(true)"
              >
                <a-icon type="plus" />
                Add new custom filter
              </a-button>
            </div>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <DynamicList
        v-if="currentForm.showFilter"
        v-model="currentForm.filterBlocks"
        @change="handleListChange"
      >
        <template
          v-slot="{
            item,
            index,
            onMoveUp,
            onMoveDown,
            onMoveTop,
            onMoveBottom,
            onRemove,
          }"
        >
          <DynamicListItem
            :title="item.title"
            :index="index"
            :isFirst="index === 0"
            :isLast="index === currentForm.filterBlocks.length - 1"
            size="big"
            @moveUp="onMoveUp"
            @moveDown="onMoveDown"
            @moveTop="onMoveTop"
            @moveBottom="onMoveBottom"
            @remove="onRemove"
          >
            <template v-if="item.custom" #actions>
              <a-button
                type="link"
                class="edit"
                @click="handleEditFilter(item.id)"
              >
                <a-icon type="edit" />
              </a-button>
            </template>
            <template v-if="item.children">
              <DynamicListItem
                v-for="match in item.children"
                :key="match"
                :has-controls="false"
                :has-delete="false"
                theme="gray"
              >
                <template #title>
                  <span class="match__name">{{ getMatchById(match)?.name }}</span>
                </template>
              </DynamicListItem>
            </template>
          </DynamicListItem>
        </template>
      </DynamicList>
    </div>

    <FilterModal
      v-if="isFilterModalOpened"
      v-model="isFilterModalOpened"
      :data="filterEditData"
      :initLang="selectedLanguage"
      @close="handleFilterModalClose"
      @submit="handleCustomFilterSubmit"
    />
  </MainContainer>
</template>
<script>
import DynamicList from '@/components/custom/list/dynamicList.vue'
import DynamicListItem from '@/components/custom/list/dynamicListItem.vue'
import MainContainer from '@/components/main/mainContainer'
import FilterModal from '@/views/apps/custom-pages/constructor/filter/FilterModal.vue'

import LanguageSelect from '@/components/custom/languageSelect.vue'

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    DynamicList,
    DynamicListItem,
    LanguageSelect,
    MainContainer,
    FilterModal,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  data() {
    return {
      rules: {
        filterTypes: [
          {
            required: true,
            message: 'Select filter type',
            trigger: ['change', 'blur'],
          },
        ],
      },
    }
  },
  computed: {
    ...mapState({
      langs: (state) => state.langs.langData,
    }),
    ...mapGetters('content', ['selectedMatches']),
    ...mapGetters('filter', [
      'selectedLanguage',
      'isFilterModalOpened',
      'filterEditData',
      'currentForm',
      'currentFilterOptions',
    ]),
    selectedLanguage: {
      get() {
        return this.$store.getters['filter/selectedLanguage']
      },
      set(value) {
        this.setSelectedLanguage(value)
      },
    },
    currentSelectedMatches() {
      return this.selectedMatches[this.selectedLanguage]
    },
  },
  methods: {
    ...mapActions('filter', [
      'setSelectedLanguage',
      'onFilterModalClose',
      'onFilterTypeSelect',
      'onFilterTypeDeselect',
      'onFilterBlockRemove',
      'onCustomFilterSubmit',
      'onCustomFilterEdit',
    ]),
    ...mapMutations('filter', ['SET_FILTER_MODAL_OPENED']),
    validateFilterTypes() {
      this.$refs.form.validateField('filterTypes')
    },
    handleFilterTypesSelect(id) {
      this.onFilterTypeSelect(id)

      this.$refs.form.validateField('filterTypes')
    },
    handleFilterTypesDeselect(id) {
      this.onFilterTypeDeselect(id)
    },
    handleListChange(data) {
      if (!data) {
        return
      }

      switch (data.action) {
        case 'remove':
          this.onFilterBlockRemove(data.item.id)
          break
      }
    },
    handleCustomFilterSubmit(data, id) {
      this.onCustomFilterSubmit({ data, id })

      this.$refs.form.validateField('filterTypes')
    },
    handleEditFilter(id) {
      this.onCustomFilterEdit(id)
    },
    handleFilterModalClose() {
      this.onFilterModalClose()
    },
    getMatchById(id) {
      return this.currentSelectedMatches.find(m => m.id === id)
    },
  },
}
</script>
<style scoped lang="scss">
.switch {
  display: flex;
  align-items: center;

  ::v-deep label {
    margin: 0;
    font-size: 18px;
    line-height: 28px;
    font-weight: 600;
    color: #262626;
  }
}

::v-deep .ant-select-selection__placeholder {
  color: #bfbfbf;
}

.filter-types {
  ::v-deep .ant-select-dropdown-menu {
    padding: 0;
  }

  ::v-deep .ant-select-dropdown-menu-item {
    padding: 9px 12px;
    font-size: 14px;
    line-height: 22px;
    color: #595959;
  }

  ::v-deep .ant-select-dropdown-menu-item-selected {
    background-color: #e6f7ff;
    font-weight: 400;
    color: #000000;
  }

  ::v-deep .ant-btn {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0;
    border: none;
    height: auto;
    font-size: 14px;
    line-height: 22px;
    padding: 9px 12px;
  }
}

::v-deep .ant-modal-mask {
  z-index: 1100;
}

::v-deep .ant-modal-wrap {
  z-index: 1150;
}

::v-deep .item__title {
  font-size: 20px;
  line-height: 28px;
}

::v-deep .item__content {
  margin-top: 16px !important;

  .item:not(:first-child) {
    margin-top: 16px;
  }
}
</style>
